import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerFilter, IVolunteerSummary, isVolunteerBoardDisabledError } from './models';

export const VOLUNTEER_SUMMARY_KEY = '/volunteering/summary';

export const useVolunteerSummaryQuery = ({
	filter = {},
	enabled = true,
	impersonationContext,
}: {
	filter?: IVolunteerFilter;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryKey: [VOLUNTEER_SUMMARY_KEY, filter, impersonationContext?.account?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IVolunteerSummary>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'volunteering/summary' }),
				'POST',
				filter
			),
		meta: {
			toastErrorMessage: (error: Error) =>
				isVolunteerBoardDisabledError(error) ? '' : 'Failed to load the volunteer summary',
		},
	});
};
